import React, { CSSProperties, ReactNode, useRef, useState, forwardRef } from "react";
import { Button, Input, Tree, TreeProps } from "rsuite";
import ClearIcon from '@mui/icons-material/Clear';

interface ITreeWithFilterProps extends TreeProps {
    afterFilterButton?: ReactNode;
}
const inputStyle = (afterFilterButton?: ReactNode): CSSProperties => {
    if (afterFilterButton)
        return { width: "calc(100% - 7rem)", marginLeft: '3rem' }

    return { width: "calc(100% - 4rem)", marginLeft: '.5rem' }
}
const TreeWithFilter = forwardRef<HTMLDivElement, ITreeWithFilterProps>(({ afterFilterButton, ...treeProps }, ref) => {
    const [searchKeyword, setSearchKeyword] = useState<string>('');

    const searchInputRef = useRef<HTMLInputElement | null>(null);
    const clearFilter = () => {
        setSearchKeyword('');
    }

    return (
        <div style={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '.5rem', display: 'flex', flex: '0 0 auto' }} >
                <Button title="Очистить фильтр" className="clearFilter" onClick={clearFilter}><ClearIcon style={{ fill: "var(--svg-fill)" }} /></Button>
                <Input style={inputStyle(afterFilterButton)} placeholder="Поиск..." ref={searchInputRef} value={searchKeyword} onChange={setSearchKeyword} />
                {afterFilterButton}
            </div>
            <div style={{ flex: '1 1 auto', minHeight: 0 }}>
                <Tree
                    ref={ref}
                    searchInputRef={searchInputRef}
                    onSearch={(keyword) => setSearchKeyword(keyword)}
                    searchKeyword={searchKeyword}
                    {...treeProps}
                />
            </div>
        </div>

    );
})
export default TreeWithFilter;